import React from 'react';

import { CircularProgress, Typography } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
  },
  text: {
    fontSize: 12,
  },
}));

export interface SyncingIndicatorProps {
  className?: string;
  size?: number;
  text?: string;
}

/**
 * Displays a spinning indicator with optional "Syncing files..." text.
 * Used to show sync progress in integrations UI.
 */
export function SyncingIndicator({
  className,
  size = 12,
  text = 'Syncing files...',
}: SyncingIndicatorProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={clsx(classes.container, className)}>
      <CircularProgress size={size} />
      <Typography className={classes.text} color="textSecondary" variant="body2">
        {text}
      </Typography>
    </div>
  );
}
